import { css } from "@stubhub/broadway-foundation/css";
import { favoriteTeamEventCardStyles } from "./FavoriteTeamEventCard.styles";

export const favoriteTeamCarouselStyles = {
  header: css({
    display: "flex",
    alignItems: "center",
    columnGap: "primitives.150",
    marginBlockEnd: "primitives.200",
  }),
  logoBadge: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "[52px]",
    height: "[52px]",
    borderStartStartRadius: "[12px]",
    borderStartEndRadius: "[12px]",
    borderEndEndRadius: "[12px]",
    borderEndStartRadius: "[12px]",
    overflowX: "hidden",
    overflowY: "hidden",
    flexShrink: 0,
  }),
  logoImage: css({
    width: "[28px]",
    height: "[28px]",
    objectFit: "contain",
  }),
  teamImage: favoriteTeamEventCardStyles.teamImage,
  fallbackAbbreviation: css({
    color: "text.onOverlay",
    fontSize: "primitives.300",
    fontWeight: "bold",
  }),
  headerText: css({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    rowGap: "primitives.50",
  }),
  teamName: css({
    fontSize: "primitives.500",
    lineHeight: "primitives.600",
    tablet: {
      fontSize: "primitives.600",
      lineHeight: "primitives.700",
      letterSpacing: "[-0.5px]",
    },
  }),
  seeAllLink: css({
    flexShrink: 0,
    marginInlineStart: "auto",
    // Broadway has no filled-light neutral variant; ghost only fills on hover.
    backgroundColor: {
      base: "bg.surface.stronger",
      _hover: "bg.surface.stronger.hover",
      _active: "bg.surface.stronger.active",
    },
  }),
  // Broadway ships only up/down arrows.
  arrowRightIcon: css({
    rotate: "[90deg]",
  }),
};
